const userRoles = [
  {
    id: 'ADMIN',
    name: 'ADMIN',
  },
  {
    id: 'EDITOR',
    name: 'EDITOR',
  },
];

export default userRoles;
